function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { FeedbackNotification } from '@ori-ui/components';
import { CheckCircle, InfoCircle, Warning, ErrorCircle } from '@ori-ui/icons';
import { useCallback, useState, useEffect } from 'react';
export var MessageType = /*#__PURE__*/ function(MessageType) {
    MessageType["Info"] = "info";
    MessageType["Success"] = "success";
    MessageType["Error"] = "error";
    MessageType["Warning"] = "warning";
    return MessageType;
}({});
export var MessageBox = function(param) {
    var _param_message = param.message, message = _param_message === void 0 ? '' : _param_message, _param_type = param.type, type = _param_type === void 0 ? "info" : _param_type, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? 2000 : _param_timeout, _param_trigger = param.trigger, trigger = _param_trigger === void 0 ? 0 : _param_trigger;
    var ShowMessage = function ShowMessage(message, type) {
        var timeoutMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2000;
        var icon;
        var color = 'initial';
        switch(type){
            case "success":
                icon = /*#__PURE__*/ _jsx(CheckCircle, {});
                color = 'success';
                break;
            case "error":
                icon = /*#__PURE__*/ _jsx(ErrorCircle, {});
                color = 'error';
                break;
            case "warning":
                icon = /*#__PURE__*/ _jsx(Warning, {});
                color = 'warning';
                break;
            case "info":
                icon = /*#__PURE__*/ _jsx(InfoCircle, {});
                color = 'initial';
                break;
            default:
                icon = /*#__PURE__*/ _jsx(CheckCircle, {});
        }
        setMessageIcon(icon);
        setMessageType(color);
        setMessageTimeout(timeoutMs);
        if (message) {
            setIsOpen(true);
        }
    };
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var handleClose = useCallback(function() {
        setIsOpen(false);
    }, []);
    var _useState1 = _sliced_to_array(useState('success'), 2), messageType = _useState1[0], setMessageType = _useState1[1];
    var _useState2 = _sliced_to_array(useState(/*#__PURE__*/ _jsx(InfoCircle, {})), 2), messageIcon = _useState2[0], setMessageIcon = _useState2[1];
    var _useState3 = _sliced_to_array(useState(timeout), 2), messageTimeout = _useState3[0], setMessageTimeout = _useState3[1];
    useEffect(function() {
        ShowMessage(message, type, timeout);
    }, [
        message,
        type,
        timeout,
        trigger
    ]);
    return /*#__PURE__*/ _jsx(FeedbackNotification, {
        open: isOpen,
        onClose: handleClose,
        icon: messageIcon,
        color: messageType,
        timeoutMs: messageTimeout,
        children: /*#__PURE__*/ _jsx("p", {
            children: message
        })
    });
};
